export const ERacBodyType = {
   0: "UNKNOWN",
   1: "SEDAN",
   2: "HATCHBACK",
   3: "SUV",
   4: "MINIVAN",
   5: "VAN",
   6: "STATION_WAGON",
   "-1": "ALL",
};

export const ERacProductType = {
   0: "UNKNOWN",
   1: "CAR",
   2: "ANCILLARY",
   "-1": "ALL",
};

export const ERacAncillaryEnums = {
   0: "UNKNOWN",
   1: "BABY_SEAT",
   2: "NAVIGATION",
   3: "INTERNET",
   4: "SNOW_TIRE",
   5: "SNOW_CHAIN",
   6: "INSURANCE_ECO",
   7: "INSURANCE_PREMIUM",
   21: "EXTRA_DAMAGE",
   22: "EXTRA_PICKUP_DROPOFF",
   23: "EXTRA_TRAFFIC_PENALTY",
   51: "MANDAT_ONEWAY_TRANSFER",
   "-1": "ALL",
};

export const ERacAncillaryTypeIcon = {
   1: "baby-seat",
   2: "navigation",
   3: "mobil-internet",
   4: "snow-tires",
   5: "snow-chain",
   6: "insurance-eco",
   7: "insurance-pro",
   8: "fast-transit-system",
   9: "additional-driver",
   10: "young-driver-pack",
   11: "additional-mileage",
   12: "other",
   13: "other_fees",
   21: "extra-damage",
   22: "extra-pickup-dropoff",
   23: "extra-traffic-penalty",
   24: "extra-damage-2",
   51: "mandat-oneway-transfer",
};

export const ERacPassengerCapacity = {
   0: "UNKNOWN",
   3: "3",
   5: "5",
   7: "7",
   9: "9",
   "-1": "ALL",
};

export const ERacAncillaryType = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "BABY_SEAT",
   2: "NAVIGATION",
   3: "INTERNET",
   4: "SNOW_TIRE",
   5: "SNOW_CHAIN",
   6: "INSURANCE_ECO",
   7: "INSURANCE_PREMIUM",
   8: "FAST_TRANSIT_SYSTEM",
   9: "ADDITIONAL_DRIVER",
   10: "YOUNG_DRIVER_PACK",
   11: "ADDITIONAL_MILEAGE",
   12: "OTHER",
   13: "OTHER_FEES",
   21: "EXTRA_DAMAGE",
   22: "EXTRA_PICKUP_DROPOFF",
   23: "EXTRA_TRAFFIC_PENALTY",
   24: "EXTRA_DAMAGE_2",
   51: "MANDAT_ONEWAY_TRANSFER",
   52: "MANDAT_OTHER_FEES",
};

export const ERacFacilityType = {
   0: "UNKNOWN",
   1: "FREE_CANCELLATION",
   2: "UNLIMITED_MILEAGE",
   3: "AIRPORT_SURCHARGE",
   4: "COLLISION_DAMAGE_WAIVER",
   5: "THEFT_WAIVER",
   6: "THIRD_PARTY_LIABILITY_INSURANCE",
   "-1": "ALL",
};

export const ERacRnrStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "RESERVED",
   3: "BOOKED",
   4: "CANCELED",
   5: "VOIDED",
   6: "REFUNDED",
   7: "REBOOKED",
   8: "ERROR",
   9: "OPEN",
   10: "PENDING",
   "-1": "ALL",
};

export const ERacVehicleStatus = {
   0: "UNKNOWN",
   1: "ACTIVE",
   2: "PASSIVE",
   "-1": "ALL",
};

export const ERacVehiclePriceStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "RESERVED",
   3: "BOOKED",
   4: "CANCELED",
   5: "VOIDED",
   6: "REFUNDED",
   7: "REBOOKED",
   8: "ERROR",
   9: "OPEN",
   10: "PENDING",
   "-1": "ALL",
};

export const ERacAncillaryStatus = {
   0: "UNKNOWN",
   1: "ACTIVE",
   2: "PASSIVE",
   "-1": "ALL",
};

export const ERacGearType = {
   0: "UNKNOWN",
   1: "MANUAL",
   2: "AUTOMATIC",
   "-1": "ALL",
};

export const ERacFuelType = {
   0: "UNKNOWN",
   1: "DIESEL",
   2: "GASOLINE",
   3: "ELECTRIC",
   4: "HYBRID",
   "-1": "ALL",
};

export const ERacImportType = {
   0: "UNKNOWN",
   1: "AUTO",
   2: "MANUAL",
   "-1": "ALL",
};

export const ERacCommissionRatioType = {
   0: "UNKNOWN",
   1: "COMMISION",
   2: "MARKUP",
   "-1": "ALL",
};

export const ERacCommissionType = {
   0: "UNKNOWN",
   1: "GTS",
   2: "GSA",
   3: "AGENCY",
   "-1": "ALL",
};

export const ERacCommissionAmountType = {
   0: "UNKNOWN",
   1: "RATIO",
   2: "FIXED",
   "-1": "ALL",
};

export const ERacProviderDocType = {
   0: "UNKNOWN",
   1: "RESERVATION",
   2: "CONTRACT",
   "-1": "ALL",
};

export const ERacRnrReverseEnabledType = {
   0: "UNKNOWN",
   1: "VOIDABLE",
   2: "REFUNDABLE_WO_PENALTY",
   3: "REFUNDABLE_WITH_PENALTY",
   4: "ALREADY_REVERSED",
   5: "UNREVERSABLE",
   "-1": "ALL",
};

export const ERacPaymentTimingType = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "PAY_ONLINE",
   2: "PAY_AT_PICKUP",
};

export const ERacRnrImplementationType = {
   0: "UNKNOWN",
   301: "pandora",
   302: "cizgi",
   303: "NEW_IMPLEMANTION",
};

export const ERacFuelPolicyType = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "FULL_TO_FULL",
   2: "SAME_TO_SAME",
};
